import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useCopy } from './copy/copyMode';
const SESSION_KEY = 'giga_intro_seen';
export function IntroSplash() {
  const copy = useCopy();
  const PHRASE = copy.introSplash.phrase;
  // Decide synchronously whether we should show, so the page never flashes
  // the splash on subsequent navigations within the same session.
  const [visible, setVisible] = useState(() => {
    if (typeof window === 'undefined') return false;
    if (sessionStorage.getItem(SESSION_KEY)) return false;
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    return !reduced;
  });
  const [typed, setTyped] = useState('');
  const [done, setDone] = useState(false);
  // Mark as seen + lock scroll while the splash is up
  useEffect(() => {
    if (!visible) return;
    sessionStorage.setItem(SESSION_KEY, '1');
    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = prevOverflow;
    };
  }, [visible]);
  // Typewriter effect
  useEffect(() => {
    if (!visible) return;
    let i = 0;
    const typeId = setInterval(() => {
      i += 1;
      setTyped(PHRASE.slice(0, i));
      if (i >= PHRASE.length) {
        clearInterval(typeId);
        // Hold briefly on the full phrase, then begin exit
        setTimeout(() => setDone(true), 950);
      }
    }, 55);
    return () => clearInterval(typeId);
  }, [visible]);
  return <AnimatePresence data-id="element-4499" data-mp="3rmnoxargpeho">
      {visible && <motion.div key="intro-splash" className="fixed inset-0 z-[100] bg-[#2B211A] flex items-center justify-center px-6" initial={{
      opacity: 1
    }} animate={done ? {
      opacity: 0,
      scale: 1.06,
      filter: 'blur(8px)'
    } : {
      opacity: 1,
      scale: 1,
      filter: 'blur(0px)'
    }} transition={{
      duration: 1.2,
      delay: done ? 0.3 : 0,
      ease: [0.16, 1, 0.3, 1]
    }} onAnimationComplete={() => {
      if (done) setVisible(false);
    }} aria-label={PHRASE} role="presentation" data-id="element-4500" data-mp="3rji3q6lyewr8">
          {/* Analog film grain overlay */}
          <div className="grain-layer-strong" data-id="element-4501" data-mp="2cngtvnsuufal" />

          <motion.h1 initial={{
        opacity: 0,
        y: 8
      }} animate={done ? {
        opacity: 0,
        y: -16
      } : {
        opacity: 1,
        y: 0
      }} transition={{
        duration: done ? 0.7 : 0.5,
        ease: done ? [0.4, 0, 0.2, 1] : 'easeOut'
      }} className="relative font-title font-medium tracking-tight text-white text-center text-[26px] sm:text-4xl md:text-6xl lg:text-7xl leading-[1.1] max-w-full md:max-w-4xl mx-auto" data-id="element-4502" data-mp="1yp0bv0pjl2d5">
            {/* Accessible full phrase for screen readers */}
            <span className="sr-only" data-id="element-4503" data-mp="1k0dwx03tucmg">{PHRASE}</span>
            <span aria-hidden="true" data-id="element-4504" data-mp="15ztbrxafw4ps">
              {typed}
              <motion.span className="inline-block w-[3px] md:w-[4px] h-[1em] -mb-[0.12em] ml-1 bg-[#EA580C] align-middle" animate={{
            opacity: [1, 1, 0, 0]
          }} transition={{
            duration: 1,
            repeat: Infinity,
            ease: 'linear',
            times: [0, 0.5, 0.5, 1]
          }} data-id="element-4505" data-mp="160bg7h799p8s" />
            </span>
          </motion.h1>
        </motion.div>}
    </AnimatePresence>;
}